import { useMemo, type ReactElement, type ReactNode } from 'react';
import { Navigate } from '@tanstack/react-router';
import { LoadingOverlay } from '@mantine/core';
import { useGetUsersCurrent } from '@/services/users';
import AclFallbackUi from './AclFallbackUi';

export type AclProps = {
  children: ReactNode;
  uiFallBack?: ReactNode;
  permissions?: Array<string | unknown>;
  redirect?: boolean;
  defaultRedirect?: string;
  fallBackElement?: ReactNode;
};

const Acl = ({
  permissions,
  children,
  redirect = false,
  defaultRedirect = '/login',
  uiFallBack = null,
  fallBackElement = null,
}: AclProps): ReactElement | null => {
  const { isLoading, data } = useGetUsersCurrent();

  const userPermissions = data?.data?.permissions?.map(({ name }) => name);
  const auth = useMemo(() => {
    if (!permissions?.length) {
      return true;
    }
    return permissions?.some((e) => userPermissions?.includes(e as string));
  }, [permissions, userPermissions]);

  if (!auth) {
    if (redirect) {
      return <Navigate to={defaultRedirect} replace />;
    }

    if (uiFallBack) {
      if (isLoading) {
        return <LoadingOverlay visible />;
      }

      return <AclFallbackUi />;
    }

    if (fallBackElement) {
      return <>{fallBackElement}</>;
    }

    return null;
  }

  return <>{children}</>;
};

export default Acl;
